import {AbstractControl} from '@angular/forms';

export class OpenApiValidators {
    static intValidator = (convert = false) => (ctrl: AbstractControl) => {
        const value = convert ? +ctrl.value : ctrl.value;
        return [undefined, null].includes(value) || Number.isInteger(value) ? null : {integer: value};
    };
    static numberValidator = (convert = false) => (ctrl: AbstractControl) => {
        const isNumber = convert ? !isNaN(ctrl.value) : typeof ctrl.value === 'number';
        return [undefined, null].includes(ctrl.value) || isNumber ? null : {number: ctrl.value};
    };
    static enumValidator = (object: object) => ({value}: AbstractControl) => !!value && !Object.values(object).includes(value) ? {wrongEnum: value} : null;
}
